import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { fetchLogbookOptions, fetchTemplateDetails } from '../api/logbookApi';
import type { LogbookTemplate } from '../types/loogBookTypes';

const PREFETCH_STALE_MS = 60_000;

export const useLogbookEditPrefetch = (): ((row: LogbookTemplate) => void) => {
  const queryClient = useQueryClient();
  return useCallback(
    (row: LogbookTemplate) => {
      void queryClient.prefetchQuery({ queryKey: ['logbookOptions'], queryFn: fetchLogbookOptions, staleTime: PREFETCH_STALE_MS });
      void queryClient.prefetchQuery({
        queryKey: ['logbookTemplate', row.logbookTemplateId],
        queryFn: () => fetchTemplateDetails(row.logbookTemplateId),
        staleTime: PREFETCH_STALE_MS,
      });
    },
    [queryClient],
  );
};
